function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "gov-doc",
  transform: "translate(-3.000000, 0.000000)",
  fill: "#3B3A42",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(2.999814, 0.000000)"
}, React.createElement("path", {
  d: "M2.24678457,27.9999989 L2.22955142,27.9998762 C0.980739481,27.9802239 -0.0194186254,26.9578648 0.000286238734,25.728 L0.000286238734,25.717 L0.000436127256,2.30031342 C-0.0211238287,1.05522596 0.973181565,0.0305558854 2.24528624,2.38031816e-13 L16.7072213,2.38031816e-13 L22.0002862,5.60231256 L22.0002862,6 L22.0001381,25.6997859 C22.0218253,26.9594549 21.0042481,28.008954 19.7374768,27.9999695 C18.6232023,27.9912673 15.5867857,27.9887512 11.2279005,27.9909772 C9.62109017,27.9917978 7.90744877,27.9932339 6.15739559,27.9951105 C5.16016186,27.9961799 4.21321341,27.9973256 3.34728065,27.9984713 C2.45063703,27.9996934 2.45063703,27.9996934 2.24678457,27.9999989 Z M3.34463442,25.9984731 C4.21072712,25.9973272 5.15784117,25.9961812 6.15525096,25.9951117 C7.90565369,25.9932347 9.61965893,25.9917983 11.2268791,25.9909775 C15.5933911,25.9887475 18.6306343,25.9912644 19.7523783,26.0000251 C19.8853756,26.0009684 20.0029395,25.8797165 20.0002862,25.717 L20.0002862,6.39768744 L15.8453426,1.99999096 L2.26953018,1.99970607 C2.11541133,2.00344362 1.99769596,2.12475385 2.00028624,2.283 L2.00028624,25.717 L2.00015956,25.7439169 C1.99800823,25.8790595 2.10963589,25.9948727 2.2554955,25.9999836 C2.44813744,25.999695 2.46528131,25.9996716 3.34463442,25.9984731 Z",
  id: "Stroke-1"
}), React.createElement("path", {
  d: "M21.0001862,6 L16.8131862,6 C16.369397,6.00774149 16.0228626,5.69649733 15.998167,5.30848235 L16.0001862,1 L14.0001862,1 L14.0001862,5.372 C14.0955347,6.9018933 15.3473775,8.02625136 16.8309845,7.9998416 L21.0001862,8 L21.0001862,6 Z",
  id: "Stroke-3"
}), React.createElement("path", {
  d: "M14.0001862,10 C14.0001862,12.7612847 11.761471,15 9.00018624,15 C6.23890149,15 4.00018624,12.7612847 4.00018624,10 C4.00018624,7.23871525 6.23890149,5 9.00018624,5 C11.761471,5 14.0001862,7.23871525 14.0001862,10 Z M12.0001862,10 C12.0001862,8.34328475 10.6569015,7 9.00018624,7 C7.34347099,7 6.00018624,8.34328475 6.00018624,10 C6.00018624,11.6567153 7.34347099,13 9.00018624,13 C10.6569015,13 12.0001862,11.6567153 12.0001862,10 Z",
  id: "Combined-Shape"
}), React.createElement("polygon", {
  id: "Stroke-7",
  points: "9.00018624 19.881966 6.00018624 21.381966 6.00018624 10 4.00018624 10 4.00018624 24.618034 9.00018624 22.118034 14.0001862 24.618034 14.0001862 10 12.0001862 10 12.0001862 21.381966"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "22px",
    height: "28px",
    viewBox: "0 0 22 28",
    version: 1.1
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/gov-doc.19fa6ff9.svg";
export { SvgComponent as ReactComponent };